import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject } from 'rxjs';
import * as moment from 'moment';

@Injectable({ providedIn: 'root' })
export class AffiliateManageService {
    affiliates: any[];
    onAffiliatesChanged: BehaviorSubject<any>;
    constructor(private httpClient: HttpClient) {
        this.affiliates = [];
        this.onAffiliatesChanged = new BehaviorSubject<any>([]);
    }

    getAffiliates() {
        return new Promise((resolve) => {
            this.httpClient
                .get(environment.apiEndpoint + 'administrator/refcode')
                .subscribe(
                    (res: any[] = []) => {
                        this.affiliates = res;
                        this.onAffiliatesChanged.next(this.affiliates);
                        resolve(res);
                    },
                    () => {
                        resolve([]);
                    }
                );
        });
    }

    createAffiliate(data) {
        return new Promise((resolve) => {
            this.httpClient
                .post(environment.apiEndpoint + 'administrator/refcode', data)
                .subscribe(
                    (res: any[] = []) => {
                        resolve(res);
                    },
                    () => {
                        resolve([]);
                    }
                );
        });
    }

    editAffiliate(data) {
        return new Promise((resolve) => {
            this.httpClient
                .put(environment.apiEndpoint + 'administrator/refcode/' + data.id, data)
                .subscribe(
                    (res: any[] = []) => {
                        resolve(res);
                    },
                    () => {
                        resolve([]);
                    }
                );
        });
    }

    exportCsv() {
        const data = this.affiliates.map((row, index) => ({
            ...row,
            index: index + 1,
        }));
        const baseHeaders = [
            'index',
            'gender',
            'fullName',
            'email',
            'phone',
            'code',
            'activate',
        ];
        const translatedHeaders = [
            "#",
            'Danh xưng',
            'Họ và tên',
            'Email',
            'Số điện thoại',
            'Referral code',
            'Trạng thái',
        ];
        const replacer = (key, value) => {
            if (value === null) {
                return '';
            }
            switch (key) {
                case 'gender':
                    return value === 'MALE' ? 'Anh' : 'Chị';
                case 'phone':
                    return "'" + value;
                case 'activate':
                    return value ? 'Active' : 'Deactive';
                default:
                    return `${value}`.trim();
            }
        };
        const csv = data.map((row) =>
            baseHeaders
                .map((fieldName) =>
                    JSON.stringify(row[fieldName], () =>
                        replacer(fieldName, row[fieldName])
                    )
                )
                .join(',')
        );
        csv.unshift(translatedHeaders.join(','));
        const csvArray = csv.join('\r\n');

        const blob = new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), csvArray], {
            type: 'text/plain;charset=UTF-8',
        });

        saveAs(blob, `${moment().format('YYYYMMDD')} - Affiliate update.csv`);
    }
}
